export default {
  user: {
    register: '/merchant-register/register',
    sendVerifiCode: '/merchant-register/send-verification-code',
    forgotPassWordCode: '/merchant-register/forget-password-code',
    checkResetCode: '/merchant-register/check-reset-code',
    resetPassword: '/merchant-register/reset-password',
    login: '/login',
    logout: '/logout/logout'
  },
  common: {
    updateNotify: '/merchant-manager/setting/notification/update',
    getCommonData: '/common-data',
    merchantUrl: '/merchant-van/van/url',
    merchantVerify: '/merchant/verify',
    getMerchantMsg: '/merchant/query',
    getFileUrl: '/file/query',
    merchantAccountQuery: '/merchant-account/query',
    getDepositType: '/merchant-deposit/query/default',
    getExchangeRate: '/merchant-deposit/queryRate',
    depositCalculate: '/merchant-deposit/calculate',
    overseasDepositCalculate: '/overseas-arrival-manager/calculate',
    getMerchantSetting: '/merchant/query/merchantSetting',
    depositeCreate: '/merchant-deposit/create',
    verifyCertificate: '/merchant-deposit/verify',
    getDepositMsg: '/merchant-deposit/detail',
    createSupplier: '/merchant-supplier/create',
    createSupplierQuick: '/merchant-supplier/create/quickly',
    querySupplierDetail: '/merchant-supplier/detail',
    querySupplierList: '/merchant-supplier/query',
    querySuppliers: '/merchant-supplier/query/page',
    queryVanHistory: '/merchant-supplier/query/van/history',
    createCard: '/merchant-van/create',
    updateCard: '/merchant-van/update',
    queryCardDetail: '/merchant-van/detail',
    closeCard: '/merchant-van/delete',
    cardTransactionRecord: '/merchant-van/query/van-transaction',
    queryAllCard: '/merchant-van/query/all',
    pageCardTransaction: '/merchant-van/page/van-transaction',
    exportCardTransaction: '/merchant-van/export/van-transaction',
    rechargeRecord: '/merchant-account/search-deposits',
    walletTransationRecord: '/merchant-account-transaction/search',
    queryAccountDetail: '/merchant-account/detail',
    queryShortVan: '/supplier/query/short-van',
    queryVan: '/supplier/query/van',
    supplierUpload: '/supplier/create/upload',
    sendEmail: '/merchant-van/email/send',
    queryMessageList: '/system-message/search',
    readMessage: '/system-message/read',
    readALLMessage: '/system-message/read-all',
    updatePassword: '/user/update/password',
    updateBaseInfo: '/user/update/base-info',
    vanDeposit: '/merchant-van/deposit',
    apiUserName: '/merchant/api_user/name',
    apiPassword: '/merchant/api_user/new_password',
    deleteSupplier: '/merchant-supplier/delete'
  }
}
